




















import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'

settings = 
  name: "CsvImportPage"
  components: { SuperContainerView }
  vue:
    data: ->
      import_key: nil
    methods:
      deleteImportedData:  ->
        return unless @import_key?.length > 5
        data = { @import_key }
        await @triggerSlug("csv_import", "purge_imported_data", data)
        @showMessage("Imported Models Deleted For #{import_key}!")
        @import_key = nil

export default VueOptions.vue settings
